import React, { useMemo } from 'react'
import { WMSTileLayer } from 'react-leaflet'

// ArcGIS REST IDs and WMS layer names differ. Keep the WMS GetCapabilities
// mapping explicit so an annual filter never requests the wrong raster.
export const PERU_FOREST_LOSS_LAYER_IDS = {
  2001: [25],
  2002: [24],
  2003: [23],
  2004: [22],
  2005: [21],
  2006: [20],
  2007: [19],
  2008: [18],
  2009: [17],
  2010: [16],
  2011: [15],
  2012: [14],
  2013: [13],
  2014: [12],
  2015: [11],
  2016: [10],
  2017: [9],
  2018: [8],
  2019: [7],
  2020: [6],
  2021: [5],
  2022: [4],
  2023: [3],
  2024: [2],
  // The current service separates anthropogenic and natural loss for 2025.
  2025: [0, 1],
}

function PeruPerdidaBosque2025Layer({ opacity = 0.6, yearRange = [2001, 2025] }) {
  const layers = useMemo(() => {
    const startYear = Math.max(2001, yearRange[0])
    const endYear = Math.min(2025, yearRange[1])
    const ids = []

    for (let year = startYear; year <= endYear; year++) {
      ids.push(...(PERU_FOREST_LOSS_LAYER_IDS[year] || []))
    }

    return ids.join(',')
  }, [yearRange])

  return (
    <WMSTileLayer
      key={layers}
      layers={layers}
      styles=""
      format="image/png"
      version="1.1.1"
      transparent
      url="https://gis.bosques.gob.pe/server/services/Interoperabilidad/perdida_bosque_humedo_2001_2025/MapServer/WMSServer"
      opacity={opacity}
    />
  )
}

export default PeruPerdidaBosque2025Layer
